<template>
    <div>
        <v-alert :dense="isMobile" :color="notification.color" rounded="lg" class="notification" :class="positionClass">
            <span class="notification-text">{{ notification.message }}</span>
        </v-alert>
    </div>
</template>

<script>
    export default {
        props: ['notification'],
        computed: {
            isMobile() {
                return this.$vuetify.breakpoint.mdAndDown;
            },
            positionClass() {
                return this.notification.position ? 'top' : 'bottom';
            },
        },
    };
</script>
<style scoped>
    .notification {
        position: fixed;
        z-index: 100;
        margin-left: 5%;
        width: 90%;
        border-radius: 15px;
    }
    .bottom {
        bottom: 0;
    }
    .top {
        top: 8vh;
    }
    .notification-text {
        font-family: Bariol;
        font-style: normal;
        font-weight: bold;

        color: white;
    }
</style>
